import { render, staticRenderFns } from "./ProjectPicker.vue?vue&type=template&id=03b5fe07&scoped=true&"
import script from "./ProjectPicker.vue?vue&type=script&lang=js&"
export * from "./ProjectPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b5fe07",
  null
  
)

export default component.exports